/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export const ToggleOffIcon = () => {
  return (
    <svg width="48" height="24" viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="24" rx="12" fill="#CDDDEE" />
      <circle cx="12" cy="12" r="10" fill="white" />
    </svg>
  );
};

export const ToggleOnIcon = () => {
  return (
    <svg width="48" height="24" viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="48" y="24" width="48" height="24" rx="12" transform="rotate(-180 48 24)" fill="#53C1A6" />
      <circle cx="36" cy="12" r="10" transform="rotate(-180 36 12)" fill="white" />
    </svg>
  );
};
